<template>
  <v-autocomplete
    :id="keyUpTargetId"
    v-model="selectedOptionValue"
    :items="modelList"
    clearable
    hide-no-data
    :disabled="disabled"
    hide-selected
    :search-input.sync="searchQuery"
    return-object
    :loading="loading"
    item-value="id"
    item-text="title"
    :label="label"
    persistent-hint
    :append-icon="hideSearchIcon || loading ? '' : 'search'"
    @change="onSelectedOptionValueChange"
    @click:append="onSearchRequest"
  />
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'WBDAutoCompleteSelectorFilter',
  props: {
    remoteOptionValue: {
      type: [String, Object],
    },
    remoteList: {
      type: Array,
    },
    modelList: {
      type: Array,
    },
    onChangeEvent: {
      type: String,
    },
    clearEvent: {
      type: String,
    },
    label: {
      type: String,
    },
    onSearchRequestCallback: {
      type: Function,
    },
    hideSearchIcon: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
  },
  data () {
    return {
      keyUpTargetId: 'wbdAutocompleteFilterEltRef',
      searchQuery: null,
      selectedOptionValue: null,
    }
  },
  computed: {
    ...mapGetters({
    }),
    getModelList () {
      return this.modelList
    },
  },
  created () {
    if (this.remoteList && this.remoteList.length) {
      this.modelList = this.remoteList
      this.selectedOptionValue = this.remoteList[0]
    }
    if (this.remoteOptionValue) {
      this.selectedOptionValue = this.remoteOptionValue
    }
    this.eventsBus.$on(this.clearEvent, () => {
      this.searchQuery = null
      this.selectedOptionValue = null
    })
  },
  mounted () {
    window.addEventListener('keyup', (event) => {
      if (!(event && event.target && event.target.id === this.keyUpTargetId)) {
        return
      }
      if (event.keyCode === 13) {
        event.preventDefault()
        this.onSearchRequest()
      }
    })
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
    }),
    onSearchRequest () {
      if (this.onSearchRequestCallback) {
        this.onSearchRequestCallback(this.searchQuery)
      }
    },
    onSelectedOptionValueChange () {
      this.$emit(
        this.onChangeEvent,
        this.selectedOptionValue ? this.selectedOptionValue.id : null,
        this.selectedOptionValue
      )
    },
  }
}
</script>
